import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegistrationWidgetService {

  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  getUserDetails(apiKey: string) {
    const headers = new HttpHeaders({
      'ApiKey': apiKey
    });
    
    return this.http.get(`${this.url}/registrationwidget/userdetails`, { headers: headers });
  }

  getAllTeamCaptains(apiKey: string, outingIterationId: string) {
    const headers = new HttpHeaders({
      'ApiKey': apiKey
    });
    return this.http.get<any[]>(`${this.url}/registrationwidget/teamcaptains`, {
      params: { outingIterationId },
      headers
    });
  }

  getOutingByRegistrationCode(apiKey: string, code: string): any {
    const headers = new HttpHeaders({
      'ApiKey': apiKey
    });
    
    return this.http.get(`${this.url}/registrationwidget/outing/${code}`, { headers: headers });
  }

  getByPlayerRegistrationCode(apiKey: string | null, code: string): any {
    const options: any = {};
    if (apiKey) {
      options.headers = new HttpHeaders({ 'ApiKey': apiKey });
    }
    return this.http.get(`${this.url}/registrationwidget/code/${encodeURIComponent(code)}`, options);
  }

  createMultipleRegistrations(data: any, apiKey: string) {
    const headers = new HttpHeaders({
      'ApiKey': apiKey
    });
    return this.http.post(`${this.url}/registrationwidget/create/multiple`, data, { headers: headers });
  }

  updatePlayerRegistration(id: string, data: any, apiKey: string) {
    const headers = new HttpHeaders({
      'ApiKey': apiKey
    });

    return this.http.put(`${this.url}/registrationwidget/update/${id}`, data, { headers: headers });
  }

  createPaymentIntent(data: any, apiKey: string) {
    const headers = new HttpHeaders({
      'ApiKey': apiKey
    });
    return this.http.post(`${this.url}/registrationwidget/paymentintent/create`, data, { headers: headers });
  }

  cancelPaymentIntent(data: any, apiKey: string) {  
    const headers = new HttpHeaders({
      'ApiKey': apiKey
    });
    return this.http.post(`${this.url}/registrationwidget/paymentintent/cancel`, data, { headers: headers });
  }

  emailPlayerRegistrationCodes(data: any, apiKey: string) {
    const headers = new HttpHeaders({
      'ApiKey': apiKey
    });
    return this.http.post(`${this.url}/registrationwidget/email/playercodes`, data, { headers: headers } );
  }
}
